function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 63.5,
  cy: 63.5,
  r: 63.5,
  fill: "#F5F4FF"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M45.1273 55.222C45.1273 53.8413 46.2466 52.722 47.6273 52.722C69.4927 52.722 88.3419 59.0573 101.773 70.2221C115.238 81.4156 123.127 97.367 123.127 116.222C123.127 117.603 122.008 118.722 120.627 118.722C119.247 118.722 118.127 117.603 118.127 116.222C118.127 98.8705 110.913 84.3219 98.5766 74.0671C86.2058 63.7835 68.555 57.722 47.6273 57.722C46.2466 57.722 45.1273 56.6027 45.1273 55.222Z",
  fill: "#6F62FF"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M64.6291 38.3863C65.4417 39.5026 65.1955 41.0663 64.0792 41.8788L45.5669 55.3544L62.3149 70.9685C63.3248 71.91 63.3802 73.492 62.4387 74.5019C61.4971 75.5118 59.9152 75.5672 58.9053 74.6257L39.9409 56.9451C39.395 56.4363 39.1051 55.7101 39.1502 54.9652C39.1954 54.2203 39.571 53.5346 40.1744 53.0954L61.1366 37.8364C62.2529 37.0238 63.8165 37.27 64.6291 38.3863Z",
  fill: "#6F62FF"
});

var SvgEnter = function SvgEnter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 127,
    height: 127,
    viewBox: "0 0 127 127",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEnter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/enter.5d624008.svg";
export { ForwardRef as ReactComponent };